module.exports = __webpack_public_path__ + "static/media/YF81_3.75896a26.jpg";